import React from 'react';
import { Briefcase, Ship, ShieldCheck, Anchor } from 'lucide-react';

export default function CoreCompetencies() {
  return (
    <div className="bg-white p-8 border border-gray-200 rounded-sm shadow-sm">
      <h3 className="text-xl font-bold text-[#1E4363] font-serif mb-6 flex items-center gap-3">
        <Briefcase size={20} className="text-[#87412A]" /> Core Competencies
      </h3>
      <ul className="space-y-4">
        <li className="flex items-start gap-3">
          <Ship className="text-[#1E4363] shrink-0 mt-0.5" size={18} />
          <span className="text-[#2C3539]/80 text-sm font-medium">Vessel Command & Cargo Management (Bulk & Liquid)</span>
        </li>
        <li className="flex items-start gap-3">
          <ShieldCheck className="text-[#1E4363] shrink-0 mt-0.5" size={18} />
          <span className="text-[#2C3539]/80 text-sm font-medium">Pre-RightShip Vetting & ISM/ISPS/MLC Auditing</span>
        </li>
        <li className="flex items-start gap-3">
          <Briefcase className="text-[#1E4363] shrink-0 mt-0.5" size={18} />
          <span className="text-[#2C3539]/80 text-sm font-medium">Commercial Chartering (Pre & Post Fixture Operations)</span>
        </li>
        <li className="flex items-start gap-3">
          <Anchor className="text-[#1E4363] shrink-0 mt-0.5" size={18} />
          <span className="text-[#2C3539]/80 text-sm font-medium">Port Captaincy & Supercargo Services</span>
        </li>
      </ul>
    </div>
  );
}